export default __webpack_public_path__ + "static/media/am1.260f921f.jpg";